// extracted by mini-css-extract-plugin
export default {"phoneNumber":"MessageContent_phoneNumber__Oz9vM","contentContainer":"MessageContent_contentContainer__MUMgX"};